export default __webpack_public_path__ + "static/media/Autoinduction_FR.d4fed09a.pdf";